// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"62efdbb8","209":"c0bfabb7","249":"73c9fc60","325":"acea980f","453":"3933f4ce"}[chunkId] + ".chunk.js";
};